
export const HomeSVG = ({ stroke = '#2D6670' }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 17H17C15.8954 17 15 17.8954 15 19V25H20V19C20 17.8954 19.1046 17 18 17Z"
        fill={stroke}
        stroke={stroke}
      />
      <path
        d="M7.875 11V23C7.875 24.6569 9.21815 26 10.875 26H23.875C25.5319 26 26.875 24.6569 26.875 23V11"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M29.875 12L18.2405 6.41542C17.6934 6.15282 17.0566 6.15282 16.5095 6.41542L4.875 12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
